const callsFindings = ({ calls = [], totalCalls = 0, taskRows = [], now = Date.now(), dialerEverUsed = totalCalls > 0, actions = {} } = {}) => {
  if (!dialerEverUsed) return [];
  const out = [];
  const list = Array.isArray(calls) ? calls : [];

  const overdue = (Array.isArray(taskRows) ? taskRows : []).filter(
    r => r.task?.taskType === "phone" && r.task?.taskDue && r.task.taskDue < now
  );
  if (overdue.length >= 1) {
    out.push({
      tone: "warn",
      key: "call_tasks_overdue",
      label: `${overdue.length} call tasks overdue`,
      text: "",
      actions: actions.openOverdueTasks ? [{ label: "Open task queue", run: actions.openOverdueTasks }] : []
    });
  }

  const total = totalCalls || list.length;
  const connected = list.filter(c => /connected/i.test(String(c.outcome || ""))).length;
  if (total >= 30 && connected / total < 0.15) {
    out.push({
      tone: "warn",
      key: "low_connect",
      label: "Low connect rate",
      text: `${Math.round((connected / total) * 100)}% over ${total} dials. Cold-mobile runs low-teens; try different hours.`,
      actions: actions.ask ? [{ label: "Best times to call?", run: () => actions.ask("When do my calls connect best? Use my call history.") }] : []
    });
  }

  // The API returns only `outcome` (the disposition's display name) -- there is
  // no `disposition` field on the row, so keying off one counted every logged
  // call as unlogged and made the voicemail rule unreachable.
  const isUnlogged = c => !c.outcome || /not logged/i.test(String(c.outcome));
  const completed = list.filter(c => !isUnlogged(c));
  const noDisposition = list.filter(isUnlogged);
  if (noDisposition.length >= 5) {
    out.push({
      tone: "neutral",
      key: "no_outcome",
      label: `${noDisposition.length} calls without outcomes`,
      text: "",
      actions: actions.logOutcomes ? [{ label: "Show them", run: actions.logOutcomes }] : []
    });
  }

  const voicemail = completed.filter(c => /voicemail|no answer|not answered/i.test(String(c.outcome || "")));
  if (completed.length >= 10 && voicemail.length / completed.length >= 0.6) {
    out.push({
      tone: "neutral",
      key: "voicemail_heavy",
      label: `${Math.round((voicemail.length / completed.length) * 100)}% voicemail`,
      text: "Most calls hit voicemail. A 20-second script that earns a callback beats hanging up.",
      actions: actions.voicemailScript ? [{ label: "Write a script", run: actions.voicemailScript }] : []
    });
  }

  return out;
};

export default callsFindings;
